import BaseCard from 'components/Cards/BaseCard';
import { FusionInputField } from 'components/index';
import { Button, InputGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { PiWarningFill } from 'react-icons/pi';

const ActionBuilderHeader = ({
  metadata,
  updateMetadata,
  readOnly,
  setShowGlobalAction,
  setInitialData,
}) => {
  return (
    <BaseCard className="global-action-builder-section flex-shrink-0">
      <div className="d-flex flex-column gap-3">
        {/* Title + input */}
        <div className="d-flex align-items-center gap-2">
          <span className="fs-5 fw-bold">
            {readOnly ? 'View' : metadata.title ? 'Edit' : 'Add'} Global Action
          </span>
          {readOnly && (
            <span className="badge bg-secondary ms-2" style={{ fontSize: '0.7rem' }}>
              Read-only
            </span>
          )}
        </div>
        <div>
          <div className="d-flex align-items-center w-100 max-w-xl gap-3">
            <div className="flex-grow-1">
              <FusionInputField
                type="text"
                name="actionTitle"
                placeholder="Title"
                onChange={(value) => updateMetadata({ title: value })}
                value={metadata.title}
                inputClassName="py-2"
                disabled={readOnly}
              />
            </div>
            {metadata.title.length === 0 && <PiWarningFill className="fs-5 text-warning" />}
          </div>
          {/* tiny helper under title when empty */}
          {metadata.title.length === 0 && (
            <div className="small text-warning mt-2">A TITLE is required.</div>
          )}
        </div>
        {/* Debounce Time */}
        <div className="d-flex flex-column flex-md-row flex-wrap align-items-start align-items-md-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span className="fw-semibold d-inline-flex align-items-center gap-1">
              Debounce Time
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Popover className="global-action-builder-popover">
                    <Popover.Header>Debounce Time (0-1800s)</Popover.Header>
                    <Popover.Body className="small">
                      Time the condition must stay true before triggering. Example: 30s means it
                      must remain true for the full 30 seconds.
                    </Popover.Body>
                  </Popover>
                }
              >
                <button
                  type="button"
                  aria-label="About debounce time"
                  className="global-action-builder-info-trigger text-muted d-inline-flex focus-ring-theme"
                >
                  <FaInfoCircle />
                </button>
              </OverlayTrigger>
            </span>
            <InputGroup>
              <FusionInputField
                type="number"
                name="debounceTime"
                onChange={(value) => updateMetadata({ debounceTime: value })}
                onBlur={() =>
                  !readOnly &&
                  updateMetadata({
                    debounceTime: Math.max(0, Math.min(1800, metadata.debounceTime)),
                  })
                }
                value={metadata.debounceTime}
                range={[0, 1800]}
                disabled={readOnly}
              />
              <InputGroup.Text>secs</InputGroup.Text>
            </InputGroup>
          </div>
          {/* Min. Event Time */}
          <div className="d-flex align-items-center gap-2">
            <span className="fw-semibold d-inline-flex align-items-center gap-1">
              Min. Event Time
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Popover className="global-action-builder-popover">
                    <Popover.Header>Min. Event Time (0-7200s)</Popover.Header>
                    <Popover.Body className="small">
                      Minimum time the action stays active once triggered. Prevents rapid on/off
                      flapping. Example: 300s keeps it on for 5 minutes.
                    </Popover.Body>
                  </Popover>
                }
              >
                <button
                  type="button"
                  aria-label="About minimum event time"
                  className="global-action-builder-info-trigger text-muted d-inline-flex focus-ring-theme"
                >
                  <FaInfoCircle />
                </button>
              </OverlayTrigger>
            </span>
            <InputGroup>
              <FusionInputField
                type="number"
                name="minEventTime"
                onChange={(value) => updateMetadata({ minEventTime: value })}
                onBlur={() =>
                  !readOnly &&
                  updateMetadata({
                    minEventTime: Math.max(0, Math.min(7200, metadata.minEventTime)),
                  })
                }
                value={metadata.minEventTime}
                disabled={readOnly}
              />
              <InputGroup.Text>secs</InputGroup.Text>
            </InputGroup>
          </div>
        </div>
        {/* Cancel button */}
        <div className="d-flex justify-content-md-end">
          <Button
            variant="primary"
            className="fw-bold p-3"
            onClick={() => {
              setShowGlobalAction(false);
              setInitialData(null);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </BaseCard>
  );
};

export default ActionBuilderHeader;
